
import EDSwitch from '../../../../../../../../../BaseComponents/Switch/EDSwitch';
import EDFormGroup from '../../../../../../../../../BaseComponents/FormGroup/EDFormGroup';
import EDFormControlLabel from '../../../../../../../../../BaseComponents/FormControlLabel/EDFormControlLabel';

interface IProps {
  printVerifikation: boolean;
  setPrintVerifikation: (print: boolean) => void;
  printFakturabilder: boolean;
  setPrintFakturabilder: (print: boolean) => void;
  printUnderlag: boolean;
  setPrintUnderlag: (print: boolean) => void;
  hasFakturaBild: boolean;
  hasUnderlag: boolean;
}

/**
 * Inställningarna för verifikationsexport
 */
const EkonomiskAnalysVerifikationExportSettings: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  return (
    <EDFormGroup>
      <>
        <EDFormControlLabel
          control={
            <EDSwitch
              checked={props.printVerifikation}
              onChange={(_, checked) => props.setPrintVerifikation(checked)}
            />
          }
          label="Skriv ut verifikation"
        />
        <EDFormControlLabel
          control={
            <EDSwitch
              disabled={!props.hasFakturaBild}
              checked={props.hasFakturaBild ? props.printFakturabilder : false}
              onChange={(_, checked) => props.setPrintFakturabilder(checked)}
            />
          }
          label="Skriv ut faktura"
        />
        <EDFormControlLabel
          control={
            <EDSwitch
              disabled={!props.hasUnderlag}
              checked={props.hasUnderlag ? props.printUnderlag : false}
              onChange={(_, checked) => props.setPrintUnderlag(checked)}
            />
          }
          label="Skriv ut underlag"
        />
      </>
    </EDFormGroup>
  );
};

export default EkonomiskAnalysVerifikationExportSettings;
